import {AbstractControl} from '@angular/forms';

export const ENTITY_NAME_FORBIDDEN_CHARACTERS = ['%', '/'];
export const ENTITY_NAME_VALIDATION_PATTERN = /^[^%\/]*$/; // forbidden characters: %, /
export const ENTITY_NAME_MAX_LENGTH = 25;

export function entityNameError(nameCtrl: AbstractControl): string {
    if (nameCtrl.valid) {
        return null;
    }
    if (nameCtrl.hasError('duplicate')) {
        return 'duplicate';
    }
    if (nameCtrl.hasError('pattern')) {
        return 'pattern';
    }
    return 'invalid'; // covers "empty"
}
